import { apiRequest, apiEndPoints, methodType } from "./_apiConfig";

export const getIntegrationsRequest = async (data = {}) => {
  return apiRequest(
    methodType.GET,
    apiEndPoints.fetchIntegrations,
    data,
    true
  );
};

export const getAmazonConsentRequest = async (data = {}) => {
  return apiRequest(
    methodType.GET,
    apiEndPoints.connectAmazon,
    data,
    true
  );
};